import React from 'react';
import { Route, BrowserRouter, Switch, Redirect } from 'react-router-dom';

import { isAuthenticated } from "./auth/auth";

import Login from './pages/Login';
import CreateStory from './pages/CreateStory';
import ListStories from './pages/ListStories';
import CreateUser from './pages/CreateUser';
import StoryDetails from './pages/StoryDetails';
import RecoverPassword from './pages/RecoverPassword';
import ResetPassword from './pages/ResetPassword';

//Here, the private routes are defined
const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            (isAuthenticated()) ? (
                <Component {...props} />
            ) : (
                    <Redirect to={{ pathname: "/", state: { from: props.location } }} />
                )
        }
    />
);

const Routes = () => (
    <BrowserRouter>
        <Switch>
            <Route component={Login} path="/" exact />
            <Route component={CreateUser} path="/new/user" />
            <Route component={RecoverPassword} path="/password/recover" />
            <Route component={ResetPassword} path="/password/reset/:token" />
            <PrivateRoute component={CreateStory} path="/new/story" />
            <PrivateRoute component={CreateStory} path="/edit/story/:id" />
            <PrivateRoute component={ListStories} path="/list/story" />
            <PrivateRoute component={StoryDetails} path="/details/story/:id" />
            <Route path="*" component={() => <h1>Page not found</h1>} />
        </Switch>
    </BrowserRouter>
);

export default Routes;